import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import moment from "moment";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
//   batch_code: "",
//   supplier_name: ""
};

const today = moment().format("YYYY-MM-DD");

const BrokerageMaterialEnteredFilter = ({ onApplyFilter, date, onClose, filters = {} , type = null }) => {

    const [filtersData, setFiltersData] = useState(initialFormData);
    const { _t } = useTranslator();
   

    const handleChange = (e) => {
        let { name, value } = e.target;
        setFiltersData({ ...filtersData, [name]: value });
    };

    useEffect(() => {
        // console.log(filtersData)
    },[filtersData]);

    const handleReset = (e) => {
        e.preventDefault();
        setFiltersData(initialFormData);
        onApplyFilter(initialFormData);
        if (onClose) {
        onClose();
        }
    };

    const handleApply = (e) => {
        e.preventDefault();
        onApplyFilter({ ...filtersData });
        if (onClose) {
        onClose();
        }
    };


  return (
    <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>
        <InputWithLabel
            label={_t("batch_code", "Batch Code")}
            type="text"
            name="batch_code"
            value={filtersData.batch_code}
            onChange={handleChange}
        />

        <InputWithLabel
            label={_t("supplier_name", "Supplier Name")}
            type="text"
            name="supplier_name"
            value={filtersData.supplier_name}
            onChange={handleChange}
        />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default BrokerageMaterialEnteredFilter;
